import { CSSProperties } from 'react'
import { css } from '@emotion/react'

export interface SizeProps {
	width?: CSSProperties['width']
	height?: CSSProperties['height']
	minWidth?: CSSProperties['minWidth']
	minHeight?: CSSProperties['minHeight']
	maxWidth?: CSSProperties['maxWidth']
	maxHeight?: CSSProperties['maxHeight']
	overflow?: CSSProperties['overflow']
	overflowX?: CSSProperties['overflowX']
	overflowY?: CSSProperties['overflowY']
}

export const SizeMods = ({
	width,
	overflow,
	overflowX,
	overflowY,
	maxWidth,
	maxHeight,
	minHeight,
	minWidth,
	height
}: SizeProps) => css`
	width: ${width};
	height: ${height};
	min-height: ${minHeight};
	min-width: ${minWidth};
	max-height: ${maxHeight};
	max-width: ${maxWidth};
	overflow: ${overflow};
	overflow-x: ${overflowX};
	overflow-y: ${overflowY};
`

SizeMods.FullWidth = SizeMods({ width: '100%' })
SizeMods.FullHeight = SizeMods({ height: '100%' })
SizeMods.FillContainer = SizeMods({ width: '100%', height: '100%' })
SizeMods.Constrained = SizeMods({ maxWidth: '100%', maxHeight: '100%' })
SizeMods.FillScreen = SizeMods({ width: '100vw', height: '100vh' })
